import { NgModule } from '@angular/core';
import { CoolLib4444Component } from './cool-lib4444.component';

@NgModule({
  declarations: [CoolLib4444Component],
  imports: [
  ],
  exports: [CoolLib4444Component]
})
export class CoolLib4444Module { }
